<template>
  <div
    class="
      $typography/size:medium
      @768/layout/border:3pt
      layout/border:2pt
      layout/flex:row
      layout/grid:gap:cap
      layout/justify:start
      layout/padding:cap
      layout/align:center
    "
    >
    <button
      :aria-label="ariaLabel"
      :gtm="gtm"
      class="link/focus"
      role="button"
      tabindex="0"
      type="button"
      @click.prevent="$emit('removePill', $event.target.value)"
      >
      <Icon
        icon-name="icon__x--16--stroke.svg"
        class="typography/icon"
      />
    </button>
    <p
      class="typography"
      v-html="title"
    />
  </div>
</template>

<script>
/**
 * FilterPill
 *
 * A dismissible Pill component.
 */
  import Icon from "../icons/icon.vue";

  export default {
    components: { Icon },

    props: {
      ariaLabel: { type: String, required: true },
      gtm: { type: String, required: true },
      title: { type: String, required: true },
    },
  };
</script>
